 import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, isEnabled, DicVal, continueSession } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const Approval = props => {

    const panelsdef = [];
    const formid = getformid("Approval", props.location.search);
    const controller = getcontroller("Approval", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const user = useSelector(state => state.user);
    const menudata = useSelector(state => state.menu);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const menus = useSelector(state => state.menu.menus);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);
    const [update, setUpdata] = useState(false);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "update": "Approval/Update",
        "getlist": "Approval/GetListData",
    }

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }


    //LIST条件チェック
    function QueryExecute(param) {
        var id = DicVal(param,"ID","");
        var status = DicVal(param,"STATUS", "");
        if (isEmpty(id)) {
            fnc.current.warnmsg("承認種別を選択してください");
            return false;
        }
        if (isEmpty(status)) {
            fnc.current.warnmsg("承認状態を選択してください");
            return false;
        }
        return true;
    }
    function SynChanged(params, columninfo, type) {
        var keys = ["PDT_OPPICD", "SJC_DENNO", "SHD_DENNO", "SSR_DENNO", "SNS_DENNO", "SSH_DENNO", "SSU_DENNO", "KHD_DENNO", "FRH_DENNO", "ZSR_DENNO", "ZSK_DENNO", "ZUR_DENNO", "ZUH_DENNO", "ZTN_DENNO"];
        var syns = ["PDT_SYNFLG1", "SJC_SYNFLG1", "SHD_SYNFLG1", "SSR_SYNFLG1", "SNS_SYNFLG1", "SSH_SYNFLG1", "SSU_SYNFLG1", "KHD_SYNFLG1", "FRH_SYNFLG1", "ZSR_SYNFLG1", "ZSK_SYNFLG1", "ZUR_SYNFLG1", "ZUH_SYNFLG1", "ZTN_SYNFLG1"];
        var key = keys[Number(type)];
        var syn = syns[Number(type)];
        params.api.forEachNode((node) => {
            if (node.data[key] === params.data[key] && node.data[key] !== params.newValue && node.data.rowid !== params.data.rowid) {
                node.setDataValue(syn, params.newValue);
            }
        });
    }
    function BuildUpdateParam(param, context) {
        if (isEmpty(context) || isEmpty(context.AGRef)) return param;
        var detail = {};
        var rows = context.AGRef.GetModifyRows();
        if (isEmpty(rows)) {
            rows = param.rowdata;
        }
        detail[param.type] = DeepCopy(rows);
        return {
            ...param,
            "detail": detail
        };
    }

    //一覧から対応する入力画面を開く
    function ListCellDoubleClick(params) {
        const code = DicVal(params.data, "SSR_DENNO", "");
        if (isEmpty(code)) return false;

        const targetMenu = menus.find(menu => menu.controller.split("?")[0] === "ProdPurchase");
        if (isEmpty(targetMenu)) {
            fnc.current.warnmsg("製商品仕入入力のメニュー権限がありません");
            return true;
        }

        let url = targetMenu.controller;
        if (!isEmpty(targetMenu.subkey)) {
            url += (url.indexOf("?") === -1 ? "?" : "&") + "subkey=" + targetMenu.subkey;
        }
        const urlParts = url.split("?");

        const state = {
            status: "ENTRY",
            code: code
        };
        const key = continueSession(user, menudata, targetMenu, state);
        url += (urlParts.length === 1 ? "?" : "&") + "key=" + key;
        window.open("/" + url);
        return true;
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
                queryexecute={QueryExecute}
                listcellchange={SynChanged}
                listcelldoubleclick={ListCellDoubleClick}
                updateparamcallback={BuildUpdateParam}
                updatelockuncheck={true}        //申請フラグ編集可
           >
            </MasterBase>
        </div>
    );
};

